// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__Jy4w3","calendarButtons":"ClockData_calendarButtons__9aZ-E"};